import { Card, Divider, Typography } from "antd";
import React from "react";
import GSM_IntrasitDashboard from "../../../components/GSuperMarket/GSM_IntrasitDashboard/GSM_IntrasitDashboard";
import "../../../styles/global-ui.css";

const GSM_BinTransitPage = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-title-wrap">
          <Typography.Title level={3} className="page-title">
            GSM In Transit
          </Typography.Title>
          <Typography.Text className="page-subtitle">
            Track bins currently moving to garment super market
          </Typography.Text>
        </div>
      </div>

      <Divider className="page-divider" />

      <Card className="modern-card">
        <GSM_IntrasitDashboard />
      </Card>
    </div>
  );
};

export default GSM_BinTransitPage;